module.exports = __webpack_public_path__ + "img/youtube.0b1c3624.svg";